module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_8011.4086b948.png";